import { useEffect, useState } from 'react';
import styles from './SideBarMaster.module.css';
import '../theme/tokens.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdOutlineDashboard, MdLogout, MdSchool, MdStore, MdPeople, MdBadge, MdRestaurantMenu, MdInsights } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb";
import { fetchWithAuth } from '../../../shared/utils/auth';

function SideBarMaster() {
    const location = useLocation();
    const navigate = useNavigate();

    // Convites de equipe parados (pendentes ou expirados) — igual um painel
    // de operações mostra quantos tickets estão em espera, não só que a fila
    // "Equipe" existe. Estrutura carregando informação real, não decoração.
    const [convitesParados, setConvitesParados] = useState(null);

    useEffect(() => {
        let ativo = true;
        const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

        fetchWithAuth(`${API_URL}/master/equipe`)
            .then((res) => (res && res.ok ? res.json() : null))
            .then((data) => {
                if (!ativo || !Array.isArray(data)) return;
                const parados = data.filter((e) => e.status !== 'ativo').length;
                setConvitesParados(parados);
            })
            .catch(() => {});

        return () => { ativo = false; };
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    const menuItems = [
        { path: "/speedhub/visaogeral", label: "Visão geral", icon: <MdOutlineDashboard /> },
        { path: "/speedhub/clientes", label: "Clientes", icon: <MdInsights /> },
        { path: "/speedhub/universidades", label: "Universidades", icon: <MdSchool /> },
        { path: "/speedhub/estabelecimentos", label: "Estabelecimentos", icon: <MdStore /> },
        { path: "/speedhub/usuarios", label: "Usuários", icon: <MdPeople /> },
        { path: "/speedhub/equipe", label: "Equipe", icon: <MdBadge />, contagem: convitesParados },
        { path: "/speedhub/itens", label: "Itens", icon: <MdRestaurantMenu /> },
        { path: "/speedhub/relatorios", label: "Relatórios", icon: <TbReportSearch /> }
    ];

    return (
        <aside className={styles.sidebar}>
            <div className={styles.wordmark}>
                <span className={styles.wordmarkMarca} aria-hidden="true">S</span>
                <div className={styles.wordmarkTexto}>
                    <span className={styles.wordmarkNome}>SpeedHub</span>
                    <span className={styles.wordmarkTagline}>console da rede</span>
                </div>
            </div>

            <nav className={styles.nav}>
                <ul className={styles.menuList}>
                    {menuItems.map(item => {
                        const ativo = location.pathname === item.path;
                        return (
                            <li key={item.path} className={styles.menuItem}>
                                <Link to={item.path} className={`${styles.menuLink} ${ativo ? styles.menuLinkAtivo : ''}`}>
                                    <span className={styles.trilho} aria-hidden="true" />
                                    <span className={styles.icon}>{item.icon}</span>
                                    <span className={styles.label}>{item.label}</span>
                                    {!!item.contagem && (
                                        <span className={styles.contagem} title={`${item.contagem} convite(s) aguardando ativação`}>
                                            {item.contagem}
                                        </span>
                                    )}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>

            <div className={styles.logoutContainer}>
                <button onClick={handleLogout} className={styles.logoutButton}>
                    <MdLogout className={styles.logoutIcon} />
                    <span>Sair da conta</span>
                </button>
            </div>
        </aside>
    );
}

export default SideBarMaster;
